import { addEvent, removeEvent, triggerEvent } from '../utils/events';

export class PriceTick {

  constructor(tickComponent, upButtonComponent, downButtonComponent, componentInput) {
    this.priceTickComponent = tickComponent;

    if (!this.isEverythingOk()) {
      return;
    }

    this.upButton = tickComponent.querySelector(upButtonComponent);
    this.downButton = tickComponent.querySelector(downButtonComponent);
    this.componentInputElement = tickComponent.querySelector(componentInput);

    this.init();
  }

  /**
   * Assigns events to the close button
   * and the filter action button (Apply)
   * @return undefined
   */
  init() {
    if (this.upButton) {
      addEvent(this.upButton, 'click', this.triggerUp.bind(this));
    }
    if (this.downButton) {
      addEvent(this.downButton, 'click', this.triggerDown.bind(this));
    }
  }

  triggerUp() {
    triggerEvent(this.priceTickComponent, 'up.commonui.pricetick');
  }

  triggerDown() {
    triggerEvent(this.priceTickComponent, 'down.commonui.pricetick');
  }

  destroy() {
    removeEvent(this.upButton, 'click', this.triggerUp.bind(this));
    removeEvent(this.downButton, 'click', this.triggerDown.bind(this));
    this.close();
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.priceTickComponent) {
      console.warn('CommonUI - Price Tick - There\'s no tick found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * Creates a new filter instance
 * @param  {Object} config
 */
export default function initFilter(config = {}) {
  const {
    selector = '.js-price-tick',
    upButtonComponent = '.js-price-tick__up',
    downButtonComponent = '.js-price-tick__down',
    componentInput = '.js-price-tick__value',
  } = config;
  let priceTicks = null;
  if (typeof selector === 'string') {
    for (const tick of document.querySelectorAll(selector)) {
      priceTicks = new PriceTick(tick, upButtonComponent, downButtonComponent, componentInput);
    }
  }
  return priceTicks;
}



// WEBPACK FOOTER //
// ./js/components/PriceTick.js